export const rowStyles = {
  padding: 0,
  '.MuiStack-root': {
    marginTop: 0,
    padding: '4px 0',
    width: '100%',
  },
};

export const tableCustomStyles = {
  '.table-body .table-cell': {
    border: 'none',
    padding: `0 !important`,
  },
  '.table-body .table-row': {
    '&:hover': {
      backgroundColor: 'transparent !important',
    },
  },
};

export const checklistListStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  padding: '12px 12px 0 25px',
  marginLeft: '25px',
  borderLeft: ({ palette }) => `1px solid ${palette.border.default}`,
  marginTop: '-12px',
};

export const accordionCustomStyles = {
  '.MuiAccordionSummary-content.Mui-expanded': {
    marginBottom: '8px',
  },
};

// * Shown in the Override column when a row has no override yet, so an empty cell reads as
// * intentionally blank rather than broken. Shared by leaf items and category rows.
export const overridePlaceholderStyles = {
  color: 'text.disabled',
};

// * Reserves the row name to its ~46% "Name" column and ellipsis-truncates it, so a
// * long name never runs under the absolutely-positioned status/action overlay on
// * narrow viewports. Shared by the leaf item name and both accordion-summary titles.
export const truncatedNameStyles = {
  maxWidth: '44%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};
